export const canHaveNestedPage = (key) => {
  switch (key) {
    case 'br':
      return true;

    case 're':
      return true;

    default:
      return false;
  }
};

export const hasItemAsString = (key) => {
  switch (key) {
    case 'br':
      return false;

    case 'brandId':
      return false;

    case 'regionId':
      return false;

    case 're':
      return false;

    default:
      return true;
  }
};

export const getNestedPageKey = (key) => {
  switch (key) {
    case 'regionId':
      return 'sites';

    case 'brandId':
      return 'carModels';

    default:
      return 'options';
  }
};

export const getMaybeParentKey = (key) => {
  switch (key) {
    case 'regionId':
      return 're';

    case 'brandId':
      return 'br';

    default:
      return key;
  }
};

export const getPageType = (key) => {
  switch (key) {
    case 'mi':
      return 'range';

    case 'pr':
      return 'range';

    case 'my':
      return 'range';

    case 'er':
      return 'range';

    case 'hp':
      return 'range';

    case 'cl':
      return 'range';

    case 'pl':
      return 'range';

    default:
      return 'checkboxes';
  }
};

export const getFilterItemLabel = (key, item) => {
  switch (key) {
    case 'br':
      return item.brandName;

    case 'brandId':
      return item.modelName;

    case 'regionId':
      return item.siteName;

    case 're':
      return item?.regionName;

    case 'fi':
      return item?.title;

    default:
      return item;
  }
};

export const getFilterItemValue = (key, item) => {
  switch (key) {
    case 'br':
      return item.brandId;

    case 'brandId':
      return item.modelId;

    case 'regionId':
      return item.siteId;

    case 're':
      return item?.regionId;

    case 'fi':
      return item?.type;

    default:
      return item;
  }
};

export const getParentItemValue = (key, item) => {
  switch (key) {
    case 'brandId':
      return item.brandId;

    case 'regionId':
      return item.regionId;

    default:
      return null;
  }
};

export const getRangeStepValue = (key) => {
  switch (key) {
    case 'pr':
      return 1000;

    case 'my':
      return 1;

    case 'mi':
      return 100;

    default:
      return 5;
  }
};

export const getMinValue = (key, value) => {
  switch (key) {
    case 'my':
      return 1920;

    case 'cl':
    case 'pl':
    case 'pr':
    case 'mi':
    case 'hp':
      return 0;

    default:
      return value;
  }
};

export const getMaxValue = (key, value) => {
  switch (key) {
    case 'pr':
      return 1000000;

    case 'mi':
      return 250000;

    default:
      return value;
  }
};

export const getRangeUnit = (key) => {
  switch (key) {
    case 'my':
      return 'år';

    case 'mi':
      return 'km';

    case 'er':
      return 'km';

    case 'cl':
    case 'pl':
    case 'pr':
      return 'pris';

    case 'hp':
      return 'hk';

    default:
      return '';
  }
};

export const getFilterTypeName = (type) => {
  switch (type) {
    case 'Site':
      return 'FORHANDLERE';

    case 'Car':
      return 'BILER';

    case 'Article':
      return 'ARTIKLER';

    default:
      return type;
  }
};

export const getNestedSubtitle = (def, key) => {
  switch (key) {
    case 're':
      return 'Anläggningar';

    default:
      return def;
  }
};

export const showRangeResult = (facet) => {
  const minRes = getMinValue(facet?.key, facet?.minValue) !== facet?.chosenMinValue;
  const maxRes = getMaxValue(facet?.key, facet?.maxValue) !== facet?.chosenMaxValue;

  return minRes || maxRes;
};
